import { render, staticRenderFns } from "./CandidateConsideredDialog.vue?vue&type=template&id=80ac3214&scoped=true"
import script from "./CandidateConsideredDialog.vue?vue&type=script&lang=js"
export * from "./CandidateConsideredDialog.vue?vue&type=script&lang=js"
import style0 from "./CandidateConsideredDialog.vue?vue&type=style&index=0&id=80ac3214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ac3214",
  null
  
)

export default component.exports